module.exports = "https://coursera_assets.s3.amazonaws.com/images/022ff9bc121defea7ec5f531409077eb.png";